import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';
import LuFormCategoryAppResource from "./LuFormCategoryAppResource";
import LuCountryAppResource from "./LuCountryAppResource";
import LuStateAppResource from "./LuStateAppResource";
import FormsetStartPageAppResource from "./FormsetStartPageAppResource";
import FormsetSuccessPageAppResource from "./FormsetSuccessPageAppResource";
import FormAppResource from "./FormAppResource";
import OrganizationAppResource from "./OrganizationAppResource";
import FileAppResource from "./FileAppResource";
import FormsetAdvertisementAppResource from "./FormsetAdvertisementAppResource";

class FormsetAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'formset';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'formsets';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'formCategoryId',
      'countryId',
      'stateId',
      'formsetStartPageUuid',
      'formsetSuccessPageUuid',
      'name',
      'description',
      'displayStartPage',
      'projectTypes',
      'forms',
      'organizations',
      'destination',
      'graphicFile',
      'graphicFileUuid',
      'issuedByAnAuthority',
      'preFormsetAdvertisementUuid',
      'postFormsetAdvertisementUuid',
      'preAdvertisement',
      'postAdvertisement',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      formCategory: LuFormCategoryAppResource,
      country: LuCountryAppResource,
      state: LuStateAppResource,
      formsetStartPage: FormsetStartPageAppResource,
      formsetSuccessPage: FormsetSuccessPageAppResource,
      forms: FormAppResource,
      projectTypes: WorkspaceTypeAppResource,
      organizations: OrganizationAppResource,
      graphicFile: FileAppResource,
      preAdvertisement: FormsetAdvertisementAppResource,
      postAdvertisement: FormsetAdvertisementAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      formCategory: 'form_category_id',
      country: 'country_id',
      state: 'state_id',
      formsetStartPage: 'formset_start_page_uuid',
      formsetSuccessPage: 'formset_success_page_uuid',
      graphicFile: 'graphic_file_uuid',
      preAdvertisement: 'pre_formset_advertisement_uuid',
      postAdvertisement: 'post_formset_advertisement_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      formCategoryId: {
        numericality: true,
        presence: true,
      },
      countryId: {
        numericality: true,
        presence: true,
      },
      stateId: {
        numericality: true,
      },
      formsetStartPageUuid: {
        type: 'string',
      },
      formsetSuccessPageUuid: {
        type: 'string',
        presence: true,
      },
      name: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        length: {
          maximum: 65535,
        },
      },
      displayStartPage: {
        type: 'boolean',
      },
      projectTypes: {
        type: 'array',
      },
      forms: {
        type: 'array',
      },
      organizations: {
        type: 'array',
      },
      destination: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      graphicFileUuid: {
        type: 'string',
      },
      preFormsetAdvertisementUuid: {
        type: 'string',
      },
      postFormsetAdvertisementUuid: {
        type: 'string',
      },
      issuedByAnAuthority: {
        type: 'boolean',
      }
    };
  }

}

export default FormsetAppResource;
